import { Accordion, Col } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { ContactDetailsForm } from '@components/UserSettings/Contacts/Form';
import { userContactsApi } from '@reducers/user/contacts';

function renderContactType(value, options) {
  if (!value) {
    return null;
  }
  const filteredOptions = options.filter((option) => option.value === value);
  if (filteredOptions.length === 0) {
    return null;
  }
  return filteredOptions[0].name;
}

function renderMailSubscription(value, options) {
  if (value.length === 0 || options.length === 0) {
    return null;
  }
  return value
    .map((item) => options.filter((option) => option.value === item)[0].name)
    .join(', ');
}

export const ContactsAccordion = ({ empty }) => {
  const mailSubscriptions = userContactsApi.useGetMailSubscriptionsQuery();
  const contactTypes = userContactsApi.useGetContactTypesQuery();
  const contactLevels = userContactsApi.useGetContactLevelsQuery();

  const { data, isLoading, isFetching } = userContactsApi.useGetListQuery();

  if (
    isLoading ||
    isFetching ||
    mailSubscriptions.isLoading ||
    contactTypes.isLoading ||
    contactLevels.isLoading
  ) {
    return <DefaultSpinnerCenter />;
  }

  if (!data) {
    return null;
  }

  return (
    <Accordion defaultActiveKey="empty">
      {empty ? (
        <Accordion.Item eventKey="empty">
          <Accordion.Header>Add contact details</Accordion.Header>
          <Accordion.Body>
            <ContactDetailsForm
              levelOptions={contactLevels.data}
              contactTypeOptions={contactTypes.data}
              mailSubscriptionOptions={mailSubscriptions.data}
              empty
            />
          </Accordion.Body>
        </Accordion.Item>
      ) : (
        data.map((item, index) => (
          <Accordion.Item eventKey={index} key={item.id}>
            <Accordion.Header>
              <Col md={6}>
                <b>
                  L{item.level}{' '}
                  {renderContactType(item.contactType, contactTypes.data)}:
                </b>{' '}
                {item.email}
              </Col>
              <Col md={1} />
              <Col className="text-end fst-italic" md={4}>
                {renderMailSubscription(
                  item.mailSubscription,
                  mailSubscriptions.data
                )}
              </Col>
            </Accordion.Header>
            <Accordion.Collapse eventKey={index} mountOnEnter>
              <Accordion.Body>
                <ContactDetailsForm
                  contactID={item.id}
                  levelOptions={contactLevels.data}
                  contactTypeOptions={contactTypes.data}
                  mailSubscriptionOptions={mailSubscriptions.data}
                />
              </Accordion.Body>
            </Accordion.Collapse>
          </Accordion.Item>
        ))
      )}
    </Accordion>
  );
};
